const angular = require('angular');

angular.module('wowApp.common')
    .directive('wowMatchExistingTextValidator', require('./match-existing-text-validator.directive'));



// WEBPACK FOOTER //
// ./src/common/matchexistingtextvalidator/index.js